(()=>{'use strict';
const M=window.EdviBagModel,pt=document.documentElement.lang.startsWith('pt'),t=(en,br)=>pt?br:en;
const root=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/'),dialog=document.querySelector('[data-cart-drawer]');
const esc=value=>String(value??'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
const money=(cents,currency=window.Shopify?.currency?.active)=>new Intl.NumberFormat(pt?'pt-BR':'en-US',{style:'currency',currency}).format(cents/100);
const selectionURL=()=>{const url=new URL(root+'collections/store-opening-set',location.origin);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);return url.href;};
const draft=()=>{try{return M?.read(localStorage.getItem(M.KEY));}catch{return null;}};
let renderedLines='',cart=null,queue=Promise.resolve(),pending=0,loading=0,busy=false,error='',trigger=null,overflow='',readSequence=0;

const nativeFetch=window.fetch.bind(window),giftProducts=new Map();
let bagMessages={};
try{bagMessages=JSON.parse(document.getElementById('EdviBundleConfig')?.textContent||'{}').messages||{};}catch{}
const confirmMessage=bagMessages.errorConfirm||t('We could not confirm your bag. Please try again.','Não foi possível confirmar sua sacola. Tente novamente.');
function responseFailure(url,response,body,invalidBody=false){
 console.warn('Edvi bag response could not be confirmed.',{url:String(url),status:response?.status||0,body:String(body||'').slice(0,200)});
 try{if(typeof window.clarity==='function')window.clarity('event','cart_json_error');}catch{}
 return Object.assign(new Error(confirmMessage),{code:'bag-response',edviResponse:true,invalidBody,status:response?.status||0});
}
function validJSONShape(data,url){
 if(!data||typeof data!=='object'||Array.isArray(data))return false;
 const path=new URL(url,location.href).pathname;
 if(/\/products\/[^/]+\.js$/.test(path))return Array.isArray(data.variants);
 if(/\/cart\/add\.js$/.test(path)){
  const lines=Array.isArray(data.items)?data.items:[data];
  return lines.length>0&&lines.every(item=>item&&Number.isSafeInteger(item.id)&&Number.isInteger(item.quantity)&&item.quantity>0);
 }
 if(/\/cart(?:\/(?:change|update|clear))?\.js$/.test(path))return typeof data.token==='string'&&data.token.length>0&&validCart(data);
 return Object.values(data).every(value=>typeof value==='string'||value===null);
}
async function decodeJSON(response,url){
 let body='',data;
 try{body=await response.text();data=JSON.parse(body);}catch{throw responseFailure(url,response,body,true);}
 if(!response.ok){
  const failure=responseFailure(url,response,body);
  failure.definitive=!!data&&typeof data==='object'&&!Array.isArray(data)&&Boolean(data.description||data.message)&&response.status>=400&&response.status<500&&![408,429].includes(response.status);
  throw failure;
 }
 if(!validJSONShape(data,url))throw responseFailure(url,response,body,true);
 return data;
}
async function recoverJSON(response,url,method='GET'){
 try{return {data:await decodeJSON(response,url),response};}
 catch(failure){
  if(!failure.invalidBody)throw failure;
  // The add caller owns attempt reconciliation. Never replay a mutation.
  if(/\/cart\/add\.js$/.test(new URL(url,location.href).pathname))throw failure;
  const mutation=method!=='GET'||/\/cart\/(?:change|update|clear)\.js$/.test(new URL(url,location.href).pathname);
  const safeURL=mutation?root+'cart.js':url;
  try{
   const next=await nativeFetch(safeURL,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
   const data=await decodeJSON(next,safeURL);
   // An uncertain change must not re-enter gift normalization and replay a POST.
   if(mutation)throw failure;
   return {data,response:next};
  }catch(nextFailure){
   if(!nextFailure.edviResponse)nextFailure=responseFailure(safeURL,null,'');
   nextFailure.edviRetried=true;
   throw nextFailure;
  }
 }
}
async function requestJSON(url,options={}){
 try{
  const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
  return (await recoverJSON(response,url,(options.method||'GET').toUpperCase())).data;
 }catch(failure){
  if(failure.edviResponse)throw failure;
  throw responseFailure(url,null,'');
 }
}
let giftQueue=Promise.resolve();
const serializeGifts=work=>{const result=giftQueue.then(work);giftQueue=result.catch(()=>{});return result;};
async function giftJSON(path,payload){
 const url=root+path;
 try{
  const response=await nativeFetch(url,{method:payload?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(payload?{'Content-Type':'application/json'}:{})},...(payload?{body:JSON.stringify(payload)}:{}),signal:AbortSignal.timeout(15000)});
  return (await recoverJSON(response,url,payload?'POST':'GET')).data;
 }catch(failure){if(failure.edviResponse)throw failure;throw responseFailure(url,null,'');}
}
async function isGift(item){
 if(item.final_price===0||item.original_price===0||item.price===0)return true;
 const productId=String(item.product_id);
 if(!giftProducts.has(productId)){
  const lookup=giftJSON('products/'+encodeURIComponent(item.handle)+'.js').then(product=>{
   const tags=Array.isArray(product.tags)?product.tags:String(product.tags||'').split(',');
   return tags.some(tag=>['gift','hidden'].includes(String(tag).trim().toLowerCase()));
  }).catch(failure=>{giftProducts.delete(productId);throw failure;});
  giftProducts.set(productId,lookup);
 }
 return giftProducts.get(productId);
}
async function normalizeGifts(current){
 if(!validCart(current))throw Error(t('Your bag could not be verified. Please refresh it.','Não foi possível conferir sua sacola. Atualize a página.'));
 const limit=current.items.length+1;
 for(let pass=0;pass<=limit;pass++){
  const flags=await Promise.all(current.items.map(isGift)),gifts=current.items.filter((item,index)=>flags[index]);
  const excess=gifts[1],oversized=gifts[0]?.quantity>1?gifts[0]:null;
  if(!excess&&!oversized)return current;
  if(pass===limit)throw Error(t('Unable to confirm your free gift. Refresh your bag.','Não foi possível confirmar seu brinde. Atualize sua sacola.'));
  current=await giftJSON('cart/change.js',{id:(excess||oversized).key,quantity:excess?0:1});
  if(!validCart(current))throw Error(t('Your bag could not be verified. Please refresh it.','Não foi possível conferir sua sacola. Atualize a página.'));
 }
}
async function guardedChange(original){
 const request=original,type=request.headers.get('Content-Type')||'';
 let payload,form=false,body='';
 try{
  if(request.method==='GET')payload=new URL(request.url).searchParams;
  else if(type.includes('application/json')){
   body=await request.clone().text();payload=JSON.parse(body);
   if(!payload||typeof payload!=='object'||Array.isArray(payload))throw new Error('Invalid cart change data');
  }else if(type.includes('multipart/form-data')||type.includes('application/x-www-form-urlencoded')){
   body=await request.clone().text();
   payload=type.includes('multipart/form-data')?await new Response(body,{headers:{'Content-Type':type}}).formData():new URLSearchParams(body);
   form=true;
  }else return nativeFetch(original);
 }catch{
  responseFailure(request.url,null,body);
  return nativeFetch(original);
 }
 const get=key=>payload instanceof URLSearchParams||form?payload.get(key):payload[key];
 const current=await giftJSON('cart.js'),line=Number(get('line')),id=String(get('id')||'');
 if(!validCart(current))throw Error(t('Your bag could not be verified. Please refresh it.','Não foi possível conferir sua sacola. Atualize a página.'));
 const item=id?current.items.find(item=>item.key===id||String(item.variant_id)===id):Number.isInteger(line)?current.items[line-1]:null;
 const quantity=Number(get('quantity'));
 if(item&&get('quantity')!==null&&get('quantity')!==undefined&&quantity!==0&&Number.isFinite(quantity)&&await isGift(item)){
  if(payload instanceof URLSearchParams||form)payload.set('quantity','1');else payload.quantity=1;
  if(request.method==='GET'){
   const url=new URL(request.url);url.search=payload.toString();
   return nativeFetch(new Request(url,request));
  }
  const headers=new Headers(request.headers);headers.delete('Content-Length');
  if(form)headers.delete('Content-Type');
  return nativeFetch(new Request(request,{headers,body:form?payload:JSON.stringify(payload)}));
 }
 return nativeFetch(request);
}
window.fetch=function(input,init){
 const url=new URL(input instanceof Request?input.url:input,location.href);
 const guarded=url.origin===location.origin&&/\/cart(?:\/change)?\.js$/.test(url.pathname);
 if(!guarded)return nativeFetch(input,init);
 let request;
 try{request=input instanceof Request?new Request(input,init):new Request(url,init);}
 catch{responseFailure(url,null,'');return nativeFetch(input,init);}
 return serializeGifts(async()=>{
  const response=await (url.pathname.endsWith('/change.js')?guardedChange(request):nativeFetch(request));
  const recovered=await recoverJSON(response,url.href,request.method);
  const original=recovered.data;
  const normalized=await normalizeGifts(original);
  if(normalized!==original&&original.sections){
   const sectionsURL=new URL(root+'cart',location.origin);sectionsURL.searchParams.set('sections',Object.keys(original.sections).join(','));
   const sections=await nativeFetch(sectionsURL,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
   normalized.sections=(await recoverJSON(sections,sectionsURL.href)).data;
  }
  const headers=new Headers(recovered.response.headers);headers.delete('Content-Length');headers.delete('Content-Encoding');headers.set('Content-Type','application/json');
  return new Response(JSON.stringify(normalized),{status:recovered.response.status,statusText:recovered.response.statusText,headers});
 });
};

async function request(path,payload){
 return requestJSON(root+path,{method:payload?'POST':'GET',headers:payload instanceof FormData?{Accept:'application/json'}:{Accept:'application/json',...(payload?{'Content-Type':'application/json'}:{})},...(payload?{body:payload instanceof FormData?payload:JSON.stringify(payload)}:{}),signal:AbortSignal.timeout(15000)});
}
function validCart(value){return value&&Array.isArray(value.items)&&/^[A-Z]{3}$/.test(value.currency)&&Number.isSafeInteger(value.total_price)&&value.total_price>=0&&value.items.every(item=>typeof item.key==='string'&&Number.isInteger(item.quantity)&&item.quantity>0&&Number.isSafeInteger(item.final_line_price)&&item.final_line_price>=0);}
async function readCart(verifiedCart){
 const sequence=++readSequence,url=new URL(root+'cart',location.origin);
 // A set commit already read and normalized this cart under the mutation lock.
 if(!validCart(verifiedCart))await request('cart.js');
 url.searchParams.set('section_id','edvi-cart-contents');
 const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
 const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'},signal:AbortSignal.timeout(15000)});
 if(!response.ok)throw Error(t('Unable to load your bag. Please refresh it.','Não foi possível carregar sua sacola. Atualize-a.'));
 const doc=new DOMParser().parseFromString(await response.text(),'text/html');
 let next;try{next=JSON.parse(doc.querySelector('[data-edvi-cart-state]')?.textContent||'null');}catch{}
 const lines=doc.querySelector('[data-edvi-cart-lines]');
 if(!validCart(next)||!lines)throw Error(t('Your bag could not be verified. Please refresh it.','Não foi possível conferir sua sacola. Atualize a página.'));
 let eligible;try{eligible=JSON.parse(doc.querySelector('[data-edvi-cart-eligibility]')?.textContent||'null');}catch{}
 if(!Array.isArray(eligible))throw Error(t('Your bag could not be verified. Please refresh it.','Não foi possível conferir sua sacola. Atualize a página.'));
 next._edviEligibleQuantity=M.eligibleQuantity(next,eligible);
 if(sequence===readSequence){cart=next;renderedLines=lines.innerHTML;render();}
 return next;
}
function validateCart(current){return M.validSelectionCart(current);}
function render(){
 const items=cart?.items||[],currency=cart?.currency||window.Shopify?.currency?.active;
 const discounts=M.discounts(cart).map(discount=>'<div class="edvi-bag-total-savings"><span>'+esc(discount.title)+'</span><strong>−'+money(discount.amount,currency)+'</strong></div>').join('');
 const savings=cart?.total_discount>0?'<p class="edvi-bag-note">'+t('Total discount','Desconto total')+' '+money(cart.total_discount,currency)+'</p>':'';
 const lines=renderedLines;
 const loadingMessage='<p role="status">'+t('Loading your bag…','Carregando sua sacola…')+'</p>';
 const saved=draft()?.group?.items?.length;
 const empty='<div class="edvi-bag-empty"><p>'+t('Your bag is empty.','Sua sacola está vazia.')+'</p><a class="edvi-bag-link" href="'+esc(selectionURL())+'">'+(saved?t('Continue building your Closing Sale set','Continuar montando seu Closing Sale set'):t('Choose your pieces','Escolha suas peças'))+'</a></div>';
 document.querySelectorAll('[data-edvi-bag]').forEach(host=>{
  const active=host.contains(document.activeElement)?document.activeElement:null,action=active?.dataset.bagAction,key=active?.dataset.bagKey,quantity=active?.dataset.bagQuantity,step=active?.dataset.bagStep,inputKey=active?.dataset.bagQuantityInput;
  host.classList.add('edvi-bag');
  host.setAttribute('aria-busy',String(loading>0||pending>0));
  if(loading){host.innerHTML='<div class="edvi-bag-body">'+loadingMessage+'</div>';return;}
  host.innerHTML='<div class="edvi-bag-body">'+lines+(!items.length?(cart?empty:'<p role="status">'+t('Loading your bag…','Carregando sua sacola…')+'</p>'):'')+'</div><footer class="edvi-bag-footer">'+(error?'<p class="edvi-bag-error" role="alert">'+esc(error)+'</p><button class="edvi-bag-link" data-bag-action="retry">'+t('Refresh bag','Atualizar sacola')+'</button>':'')+(items.length?discounts+savings+'<div class="edvi-bag-total"><span>'+t('Current subtotal','Subtotal atual')+'</span><strong>'+money(cart.total_price,currency)+'</strong></div>'+'<button class="edvi-bag-checkout" data-bag-action="checkout">'+(busy?t('Opening checkout…','Abrindo checkout…'):t('Checkout','Finalizar compra'))+'</button>':'')+'</footer>';
  host.querySelectorAll('button').forEach(button=>button.disabled=busy||pending>0||button.hasAttribute('data-bag-at-limit'));
  host.querySelectorAll('[data-bag-quantity-input]').forEach(input=>input.readOnly=busy||pending>0);
  if(action)host.querySelector('[data-bag-action="'+action+'"]')?.focus({preventScroll:true});
  else if(inputKey)[...host.querySelectorAll('[data-bag-quantity-input]')].find(input=>input.dataset.bagQuantityInput===inputKey)?.focus({preventScroll:true});
  else if(key){const button=[...host.querySelectorAll('[data-bag-key]')].find(button=>button.dataset.bagKey===key&&(step?button.dataset.bagStep===step:button.dataset.bagQuantity===quantity));(button?.disabled?button.closest('.edvi-bag-stepper')?.querySelector('input'):button)?.focus({preventScroll:true});}
 });
 document.querySelectorAll('[data-cart-count]').forEach(element=>{element.textContent=String(cart?.item_count||0);element.hidden=!cart?.item_count;});
}
function transact(task,{verifiedResult=false}={}){
 pending++;render();
 const work=async()=>{const result=await task();await readCart(verifiedResult?result:null);error='';try{localStorage.setItem('edvi-bag-cart-event',crypto.randomUUID());}catch{}return result;};
 const result=queue.then(()=>navigator.locks?navigator.locks.request('edvi-cart-mutations',work):work());
 queue=result.catch(failure=>{if(!failure.edviResponse)responseFailure(root+'cart.js',null,'');error=confirmMessage;});
 return result.finally(()=>{pending--;render();});
}
async function refresh(){try{await queue;await readCart();error='';}catch(failure){if(!failure.edviResponse)responseFailure(root+'cart.js',null,'');error=confirmMessage;}render();}
const mutate=(path,payload)=>transact(()=>request(path,payload));
function stage(input){
 try{const prior=draft(),record=M.stage(input,prior);localStorage.setItem(M.KEY,JSON.stringify(record));return Promise.resolve(record);}catch(failure){return Promise.reject(failure);}
}
function clearDraft(){try{localStorage.setItem(M.KEY,JSON.stringify(M.empty()));sessionStorage.removeItem('edvi-owned-pending');sessionStorage.removeItem('edvi-final-set:v2:store-opening-set');}catch{}}
async function checkout(){
 if(busy||pending||loading)return;busy=true;render();
 try{await transact(async()=>{const current=await readCart();if(!current.item_count)throw Error(t('Your bag is empty.','Sua sacola está vazia.'));});document.dispatchEvent(new Event('edvi-bag:checkout-handoff'));location.assign(root+'checkout');}catch(failure){if(!failure.edviResponse)responseFailure(root+'cart.js',null,'');error=confirmMessage;}finally{busy=false;render();}
}
function open(from,{refresh:shouldRefresh=true}={}){trigger=from||document.activeElement;if(dialog&&!dialog.open){overflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';dialog.querySelector('[data-close-cart]')?.focus();document.dispatchEvent(new Event('edvi-bag:open'));}if(shouldRefresh&&!loading)void refresh();}
// Open before validation/network work without exposing stale totals or controls.
// The caller settles exactly once, including recovery after an ambiguous write.
function beginPending(from){
 loading++;error='';render();open(from,{refresh:false});
 let settled=false;
 return (failed=false)=>{if(settled)return;settled=true;loading--;render();if(failed)close();};
}
function close(){dialog?.close();}
dialog?.addEventListener('close',()=>{if(document.querySelector('dialog[open]'))return;document.body.style.overflow=overflow;const target=trigger?.isConnected?trigger:document.querySelector('[data-open-cart]');target?.focus();});
dialog?.addEventListener('click',event=>{if(event.target===dialog)close();});
dialog?.addEventListener('keydown',event=>{if(event.key!=='Tab')return;const nodes=[...dialog.querySelectorAll('button:not(:disabled),input:not(:disabled),a[href],[tabindex="0"]')].filter(node=>node.getClientRects().length),first=nodes[0],last=nodes.at(-1);if(!first){event.preventDefault();return;}if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}});
document.querySelectorAll('[data-close-cart]').forEach(button=>button.addEventListener('click',close));
document.querySelectorAll('[data-open-cart]').forEach(button=>button.addEventListener('click',event=>{event.preventDefault();open(button);}));
function applyQuantity(input){
 if(busy||pending||loading)return;
 const key=input.dataset.bagQuantityInput,item=cart?.items.find(item=>item.key===key);
 if(!item)return;
 if(!input.checkValidity()){input.reportValidity();return;}
 const quantity=input.valueAsNumber;
 if(!Number.isInteger(quantity)||quantity<1||quantity>99||quantity===item.quantity)return;
 const identify=value=>JSON.stringify([String(value.variant_id||value.id),Object.entries(value.properties||{}).sort(([a],[b])=>a.localeCompare(b)),value.selling_plan_allocation?.selling_plan?.id||null]);
 const host=input.closest('[data-edvi-bag]'),restoreFocus=document.activeElement===input,identity=identify(item);
 void mutate('cart/change.js',{id:key,quantity}).catch(()=>{}).finally(()=>{
  if(!restoreFocus)return;
  requestAnimationFrame(()=>{
   if(document.activeElement!==document.body)return;
   const nextKey=cart?.items.find(value=>identify(value)===identity)?.key||key;
   const next=[...host.querySelectorAll('[data-bag-quantity-input]')].find(field=>field.dataset.bagQuantityInput===nextKey);
   if(next?.getClientRects().length)next.focus({preventScroll:true});
  });
 });
}
document.addEventListener('change',event=>{if(event.target.matches('[data-bag-quantity-input]'))applyQuantity(event.target);});
document.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('[data-bag-quantity-input]')){event.preventDefault();applyQuantity(event.target);}});
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-bag-action],[data-bag-key]');if(!button||button.disabled)return;
 if(button.dataset.bagKey){const quantity=Number(button.dataset.bagQuantity);if(Number.isInteger(quantity)&&quantity>=0&&quantity<=99)void mutate('cart/change.js',{id:button.dataset.bagKey,quantity}).catch(()=>{});return;}
 if(button.dataset.bagAction==='checkout')void checkout();
 if(button.dataset.bagAction==='retry')void refresh();
});
window.EdviBag={requestJSON,confirmMessage,stage,clearDraft,transact,open,beginPending,refresh,validateCart,inspect:readCart,flush:()=>queue,add:form=>mutate('cart/add.js',form)};
window.edviCart={refresh:async(show=true)=>{await refresh();if(show)open();},open,flush:()=>queue};
addEventListener('storage',event=>{if(event.key==='edvi-bag-cart-event')void refresh();});
addEventListener('pageshow',()=>{busy=false;void refresh();});
render();void refresh();
})();
